import React from "react";
import { VideoManagement } from "./videoManagement";

export const VariablesToTest = ({
  itemTest,
  saveDataRef,
  setBtnLoading,
  callGetCombine,
}) => {
  const calculateVerticalJump = (fieldId) => {
    const aux1 = document.getElementById(`item-aux-1-${fieldId}`).value;
    const aux2 = document.getElementById(`item-aux-2-${fieldId}`).value;
    const aux3 = document.getElementById(`item-aux-3-${fieldId}`).value;
    const aux4 = document.getElementById(`item-aux-4-${fieldId}`).value;
    const field = document.getElementById(`item-${fieldId}`);

    if (aux1 >= 0 && aux2 >= 0 && aux3 >= 0 && aux4 >= 0) {
      const ftToIn1 = aux1 * 12;
      const inches1 = parseInt(ftToIn1) + parseFloat(aux2);
      const ftToIn2 = aux3 * 12;
      const inches2 = parseInt(ftToIn2) + parseFloat(aux4);
      const verticalJump = inches1 - inches2;
      const verticalJumpAbs = verticalJump < 0 ? -verticalJump : verticalJump;

      field.value = !isNaN(verticalJumpAbs) ? verticalJumpAbs : 0;
    }
  };
  return (
    <div className="grid grid-cols-2 gap-2 my-2 even:bg-[#E6E3E3]">
      <div className="flex flex-col justify-center my-1">
        {itemTest.aux && (
          <>
            <label className="text-left text-gray-600 ml-3">
              Standing reach:
            </label>
            <div className="flex items-center mb-2">
              <input
                type={itemTest.type}
                id={`item-aux-1-${itemTest.fieldId}`}
                className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5"
                placeholder={itemTest.fieldPlaceHolder}
                min={0}
                step={itemTest.step}
                onChange={() => calculateVerticalJump(itemTest.fieldId)}
                onWheel={(e) => e.currentTarget.blur()}
              />
              <input
                type={itemTest.type}
                id={`item-aux-2-${itemTest.fieldId}`}
                className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5"
                placeholder={itemTest.placeholder}
                min={0}
                step={itemTest.step}
                onChange={() => calculateVerticalJump(itemTest.fieldId)}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </div>

            <label className="text-left text-gray-600 ml-3">
              Maximum jump reach:
            </label>
            <div className="flex items-center mb-2">
              <input
                type={itemTest.type}
                id={`item-aux-3-${itemTest.fieldId}`}
                className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5"
                placeholder={itemTest.fieldPlaceHolder}
                min={0}
                step={itemTest.step}
                onChange={() => calculateVerticalJump(itemTest.fieldId)}
                onWheel={(e) => e.currentTarget.blur()}
              />
              <input
                type={itemTest.type}
                id={`item-aux-4-${itemTest.fieldId}`}
                className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5"
                placeholder={itemTest.placeholder}
                min={0}
                step={itemTest.step}
                onChange={() => calculateVerticalJump(itemTest.fieldId)}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </div>
          </>
        )}

        {itemTest.aux && (
          <label className="text-left text-gray-600 ml-3">Vertical jump:</label>
        )}

        <div
          className={`flex ${
            itemTest.subFields?.topSpeed
              ? "flex-col items-start gap-2 sm:flex-row sm:items-center sm:gap-0"
              : "items-center"
          }`}
        >
          {/* WEIGHT + REPS */}
          {itemTest.fieldId === 7 ? (
            <>
              <div className="flex flex-col ml-3">
                <label className="text-sm text-gray-600 mb-1">Weight</label>
                <input
                  type={itemTest.type}
                  id={`item-1-${itemTest.fieldId}`}
                  className="bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg w-16 md:w-20 p-2.5"
                  placeholder="Weight"
                  min={0}
                  step={itemTest.unit === "lbs" ? "0.01" : itemTest.step}
                  readOnly={itemTest.readOnly}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </div>

              <div className="flex flex-col ml-3">
                <label className="text-sm text-gray-600 mb-1">Reps</label>
                <input
                  type={itemTest.type}
                  id={`item-${itemTest.fieldId}`}
                  className="bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg w-16 md:w-20 p-2.5"
                  placeholder="Reps"
                  min={0}
                  step={itemTest.step}
                  readOnly={itemTest.readOnly}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center">
                {/* LABEL DEL STAGE */}
                {itemTest.stageAsField && itemTest.fieldId !== 9 ? (
                  <input
                    type={itemTest.type}
                    id={`item-1-${itemTest.fieldId}`}
                    className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5"
                    placeholder={itemTest.fieldPlaceHolder}
                    min={0}
                    step={itemTest.unit === "lbs" ? "0.01" : itemTest.step}
                    readOnly={itemTest.readOnly}
                    onWheel={(e) => e.currentTarget.blur()}
                  />
                ) : (
                  itemTest.stageLabel && (
                    <span className="pl-6 pr-4">{itemTest.stage}:</span>
                  )
                )}

                <input
                  type={itemTest.type}
                  id={`item-${itemTest.fieldId}`}
                  className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5"
                  placeholder={itemTest.placeholder}
                  min={0}
                  step={itemTest.step}
                  readOnly={itemTest.readOnly}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </div>
              {itemTest.subFields?.topSpeed && (
                <div className="flex items-center ml-6">
                  <label className="mr-2 w-10 whitespace-normal font-normal leading-tight sm:w-auto sm:whitespace-nowrap">
                    {itemTest.subFields.topSpeed.label}
                  </label>

                  <input
                    type="number"
                    id={`item-aux-1-${itemTest.fieldId}`}
                    className="bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-20 p-2.5"
                    placeholder="0.000"
                    min={0}
                    step={itemTest.subFields.topSpeed.step}
                    defaultValue={itemTest.subFieldValues?.topSpeed ?? 0}
                    onWheel={(e) => e.currentTarget.blur()}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <VideoManagement
        itemTest={itemTest}
        saveDataRef={saveDataRef}
        setBtnLoading={setBtnLoading}
        callGetCombine={callGetCombine}
      />
    </div>
  );
};
